/* ============================================================
   MAISON IDRISSI — Global Scripts
   ============================================================ */

(function () {
  'use strict';

  // Tells the CSS safety net that scroll-reveal is running (see maison-idrissi.css §4)
  document.documentElement.classList.add('mi-reveal-ready');

  /* ----------------------------------------------------------
     1. Custom Cursor — fully inline, no CSS class dependency
        Kill-switches: small viewports, touch devices, reduced-motion
     ---------------------------------------------------------- */
  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isCoarsePointer       = window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches;
  var cursorEligible        = window.innerWidth > 989 && !prefersReducedMotion && !isCoarsePointer;

  if (cursorEligible) {

    var dot = document.createElement('div');
    dot.style.cssText = [
      'position:fixed',
      'top:0',
      'left:0',
      'width:10px',
      'height:10px',
      'background:#1C1A18',
      'box-shadow:0 0 0 2px #F2EDE4,0 0 0 3px rgba(28,26,24,0.25)',
      'border-radius:50%',
      'pointer-events:none',
      'z-index:2147483647',
      'display:none',
      'will-change:transform'
    ].join(';');

    var ring = document.createElement('div');
    ring.style.cssText = [
      'position:fixed',
      'top:0',
      'left:0',
      'width:38px',
      'height:38px',
      'border:1.5px solid rgba(28,26,24,0.45)',
      'border-radius:50%',
      'pointer-events:none',
      'z-index:2147483647',
      'display:none',
      'margin:-19px 0 0 -19px',
      'transition:width 0.45s cubic-bezier(0.25,0.46,0.45,0.94),height 0.45s cubic-bezier(0.25,0.46,0.45,0.94),margin 0.45s cubic-bezier(0.25,0.46,0.45,0.94),border-color 0.3s',
      'will-change:transform'
    ].join(';');

    document.body.appendChild(dot);
    document.body.appendChild(ring);

    // Force cursor:none on everything — body alone doesn't override <a>/<button>
    var cursorStyle = document.createElement('style');
    cursorStyle.textContent = '*{cursor:none!important}' +
      'input:not([type=checkbox]):not([type=radio]):not([type=submit]):not([type=button]),textarea{cursor:text!important}';
    document.head.appendChild(cursorStyle);

    var mouseX = 0, mouseY = 0;
    var ringX  = 0, ringY  = 0;
    var started = false;
    var rafId = null;

    function animateRing() {
      ringX += (mouseX - ringX) * 0.12;
      ringY += (mouseY - ringY) * 0.12;
      ring.style.transform = 'translate3d(' + ringX + 'px,' + ringY + 'px,0)';
      // Sleep once the ring has caught up; the next mousemove wakes it
      if (Math.abs(mouseX - ringX) < 0.1 && Math.abs(mouseY - ringY) < 0.1) { rafId = null; return; }
      rafId = requestAnimationFrame(animateRing);
    }

    document.addEventListener('mousemove', function (e) {
      mouseX = e.clientX;
      mouseY = e.clientY;
      dot.style.transform = 'translate3d(' + (mouseX - 5) + 'px,' + (mouseY - 5) + 'px,0)';
      if (!started) {
        started = true;
        ringX = mouseX;
        ringY = mouseY;
        dot.style.display  = 'block';
        ring.style.display = 'block';
        document.body.style.cursor = 'none';
      }
      if (!rafId) rafId = requestAnimationFrame(animateRing);
    }, { passive: true });

    document.addEventListener('mouseover', function (e) {
      if (e.target.closest('a, button, [role="button"], input, textarea, select, label')) {
        ring.style.width  = '56px';
        ring.style.height = '56px';
        ring.style.margin = '-28px 0 0 -28px';
        ring.style.borderColor = '#C4A882';
      } else {
        ring.style.width  = '38px';
        ring.style.height = '38px';
        ring.style.margin = '-19px 0 0 -19px';
        ring.style.borderColor = 'rgba(28,26,24,0.45)';
      }
    });
  }

  /* ----------------------------------------------------------
     2. Navigation — scroll state + dark mode detection
     ---------------------------------------------------------- */
  var nav = document.querySelector('.mi-nav');

  if (nav) {
    // Detect if first page section has a dark full-screen hero
    // by checking for known dark-hero section class names
    var darkHeroSelectors = [
      '.mi-os-hero',
      '.mi-craft-hero',
      '.mi-faq-hero',
      '.mi-hero-split'
    ];

    function hasDarkHero() {
      var firstSection = document.querySelector('#MainContent > .shopify-section:first-child');
      if (!firstSection) return false;
      return darkHeroSelectors.some(function (sel) {
        return firstSection.querySelector(sel) !== null;
      });
    }

    function updateNavMode() {
      if (hasDarkHero()) {
        nav.classList.add('mi-nav--dark');
      } else {
        nav.classList.remove('mi-nav--dark');
        // On light-background pages the nav should be visible immediately
        nav.classList.add('mi-nav--scrolled');
      }
    }

    updateNavMode();

    var lastScrollY = 0;
    var NAV_H = nav.offsetHeight || 72;

    window.addEventListener('scroll', function () {
      var currentY = window.scrollY;
      var isMobile = window.innerWidth <= 989;

      // ── Mobile: hide nav on scroll down, reveal on scroll up ──
      if (isMobile) {
        if (currentY > NAV_H + 20) {
          if (currentY > lastScrollY + 4) {
            nav.classList.add('mi-nav--hidden');
          } else if (currentY < lastScrollY - 4) {
            nav.classList.remove('mi-nav--hidden');
          }
        } else {
          nav.classList.remove('mi-nav--hidden');
        }
      } else {
        nav.classList.remove('mi-nav--hidden');
      }

      lastScrollY = currentY;

      // ── Frosted glass on scroll ──
      if (currentY > 30) {
        nav.classList.add('mi-nav--scrolled');
      } else {
        nav.classList.remove('mi-nav--scrolled');
        updateNavMode();
      }
    }, { passive: true });
  }

  /* ----------------------------------------------------------
     3. Scroll Reveal — IntersectionObserver
        Honors .reveal-d1 .. .reveal-d4 stagger classes.
        This is the single source of truth — no per-section duplicates.
     ---------------------------------------------------------- */
  function initReveal(root) {
    var scope = root || document;
    var els   = scope.querySelectorAll('.reveal:not(.in)');
    if (!els.length) return;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        // Delay derived from class (CSS transition-delay also covers it,
        // but a tiny JS delay smooths layered reveals after long scrolls).
        var delay = 0;
        if      (el.classList.contains('reveal-d1')) delay = 80;
        else if (el.classList.contains('reveal-d2')) delay = 160;
        else if (el.classList.contains('reveal-d3')) delay = 240;
        else if (el.classList.contains('reveal-d4')) delay = 320;
        else if (el.classList.contains('reveal-d5')) delay = 400;
        setTimeout(function () { el.classList.add('in'); }, delay);
        observer.unobserve(el);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px 60px 0px' });

    els.forEach(function (el) { observer.observe(el); });
  }

  initReveal();
  // Expose for sections that inject content dynamically (filtering, etc.)
  window.MI_initReveal = initReveal;

  /* ----------------------------------------------------------
     4. Mobile Nav Drawer
     ---------------------------------------------------------- */
  var mobileToggle  = document.querySelector('.mi-nav__mobile-toggle');
  var mobileDrawer  = document.querySelector('.mi-nav__mobile-drawer');
  var mobileOverlay = document.querySelector('.mi-nav__mobile-overlay');
  var mobileClose   = document.querySelector('[data-mi-mobile-close]');
  var mobileLinks   = document.querySelectorAll('.mi-nav__mobile-link');

  function closeDrawer() {
    if (!mobileDrawer || !mobileDrawer.classList.contains('open')) return;
    mobileDrawer.classList.remove('open');
    mobileDrawer.inert = true;
    if (mobileOverlay) mobileOverlay.classList.remove('open');
    if (mobileToggle) {
      mobileToggle.classList.remove('active');
      mobileToggle.setAttribute('aria-expanded', 'false');
    }
    document.body.classList.remove('mi-drawer-open');
    if (mobileToggle) mobileToggle.focus();
  }

  function openDrawer() {
    if (!mobileDrawer) return;
    mobileDrawer.inert = false;
    mobileDrawer.classList.add('open');
    if (mobileOverlay) mobileOverlay.classList.add('open');
    if (mobileToggle) {
      mobileToggle.classList.add('active');
      mobileToggle.setAttribute('aria-expanded', 'true');
    }
    document.body.classList.add('mi-drawer-open');
    if (mobileClose) mobileClose.focus();
  }

  if (mobileToggle && mobileDrawer) {
    mobileToggle.addEventListener('click', function () {
      if (mobileDrawer.classList.contains('open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });
  }

  if (mobileClose)   mobileClose.addEventListener('click', closeDrawer);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeDrawer);

  // Close after tapping any link (so going to a new page on same site feels right)
  mobileLinks.forEach(function (link) {
    link.addEventListener('click', closeDrawer);
  });

  // Close on escape; trap Tab inside the open drawer
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
    if (e.key === 'Tab' && mobileDrawer && mobileDrawer.classList.contains('open')) {
      var focusables = mobileDrawer.querySelectorAll('a[href], button:not([disabled])');
      if (!focusables.length) return;
      var first = focusables[0], last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ----------------------------------------------------------
     5. Accordion — one open at a time per group
     ---------------------------------------------------------- */
  document.querySelectorAll('.mi-accordion').forEach(function (group) {
    group.querySelectorAll('.mi-accordion__trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item    = trigger.closest('.mi-accordion__item');
        var isOpen  = item.classList.contains('open');

        // Close all in this group
        group.querySelectorAll('.mi-accordion__item.open').forEach(function (openItem) {
          openItem.classList.remove('open');
          openItem.querySelector('.mi-accordion__trigger').setAttribute('aria-expanded', 'false');
        });

        // Open clicked if it was closed
        if (!isOpen) {
          item.classList.add('open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });

  /* ----------------------------------------------------------
     6. Marquee — duplicate items for seamless loop
     ---------------------------------------------------------- */
  document.querySelectorAll('.mi-marquee__track').forEach(function (track) {
    var clone = track.innerHTML;
    track.innerHTML = clone + clone;
  });

})();
